(function() {
    'use strict';

    angular
        .module('bhsApp')
        .controller('TableauRepartitionAccidentsAvecArretCtrl', TableauRepartitionAccidentsAvecArretCtrl);

    TableauRepartitionAccidentsAvecArretCtrl.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService'];

    function TableauRepartitionAccidentsAvecArretCtrl ($scope, $state, ParseLinks, AlertService) {
        var vm = this;

    }
})();
